import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, LinkIcon, DownloadIcon, FlagIcon, MessageSquareIcon } from 'lucide-react';
interface ShareSheetProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ShareSheet({
  isOpen,
  onClose
}: ShareSheetProps) {
  const shareTargets = [{
    icon: LinkIcon,
    label: 'Copy Link',
    color: 'bg-surface2 text-white'
  }, {
    icon: MessageSquareIcon,
    label: 'Messages',
    color: 'bg-green-500 text-white'
  }, {
    icon: () => <span className="font-bold text-xl" data-id="element-169">W</span>,
    label: 'WhatsApp',
    color: 'bg-[#25D366] text-white'
  }, {
    icon: () => <span className="font-bold text-xl" data-id="element-170">IG</span>,
    label: 'Instagram',
    color: 'bg-gradient-to-tr from-yellow-400 via-red-500 to-purple-500 text-white'
  }, {
    icon: () => <span className="font-bold text-xl" data-id="element-171">X</span>,
    label: 'X',
    color: 'bg-black border border-border text-white'
  }];
  const actions = [{
    icon: DownloadIcon,
    label: 'Save Video'
  }, {
    icon: FlagIcon,
    label: 'Report'
  }, {
    icon: XIcon,
    label: 'Not Interested'
  }];
  return <AnimatePresence data-id="element-172">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-black/60 z-40" data-id="element-173" />

          <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="absolute bottom-0 left-0 right-0 bg-surface rounded-t-3xl z-50 pb-8" data-id="element-174">
            <div className="w-full flex justify-center py-3" data-id="element-175">
              <div className="w-12 h-1.5 bg-border rounded-full" data-id="element-176" />
            </div>

            <div className="px-4 pb-4 flex items-center justify-between" data-id="element-177">
              <h3 className="text-white font-bold" data-id="element-178">Share to</h3>
              <button onClick={onClose} className="w-8 h-8 flex items-center justify-center bg-surface2 rounded-full text-softGray hover:text-white" data-id="element-179">
                <XIcon size={18} data-id="element-180" />
              </button>
            </div>

            {/* Share Targets Scroll */}
            <div className="flex overflow-x-auto no-scrollbar px-4 pb-6 gap-4" data-id="element-181">
              {shareTargets.map((target, i) => {
            const Icon = target.icon;
            return <div key={i} className="flex flex-col items-center gap-2 shrink-0" data-id="element-182">
                    <button className={`w-14 h-14 rounded-full flex items-center justify-center ${target.color}`} data-id="element-183">
                      {typeof Icon === 'function' ? <Icon data-id="element-184" /> : <Icon size={24} data-id="element-185" />}
                    </button>
                    <span className="text-xs text-softGray" data-id="element-186">
                      {target.label}
                    </span>
                  </div>;
          })}
            </div>

            <div className="h-px bg-border mx-4 mb-6" data-id="element-187" />

            {/* Actions Scroll */}
            <div className="flex overflow-x-auto no-scrollbar px-4 gap-4" data-id="element-188">
              {actions.map((action, i) => <div key={i} className="flex flex-col items-center gap-2 shrink-0" data-id="element-189">
                  <button className="w-14 h-14 rounded-full flex items-center justify-center bg-surface2 text-white" data-id="element-190">
                    <action.icon size={24} data-id="element-191" />
                  </button>
                  <span className="text-xs text-softGray" data-id="element-192">{action.label}</span>
                </div>)}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}